import React from "react";
import { reactLocalStorage } from "reactjs-localstorage";
import { Table } from "react-bootstrap";
import withRouter from "../../../util/WithRouter";
import Constants from "../../../util/Constants";
import ApiUiController from "../../../controller/ApiUiController";
import DailySalesReportAPI from './../../../api/DailySalesReportAPI';
import ChartComponent from "../FixedReportChart";

class DailySalesLeadByProject extends React.Component {
  constructor(props) {
    super(props);
    // Load project options from local storage
    const ProjectOptions = reactLocalStorage.getObject(Constants.Model).project.options;

    this.state = {
      ProjectOptions,  // Predefined project options
      ProjectSums: {},
    };
  }

  componentDidMount() {
    // Fetch data from the API
    DailySalesReportAPI.getDailyLeadsByProject(
      this.props.filters,
      this.handleReceivedData,
      this.handleFail
    );
  }

  handleReceivedData = (data) => {
    const {  ProjectOptions } = this.state;
     // Create a record of sums for each project option, starting at 0
     const ProjectSums = ProjectOptions.reduce((acc, option) => {
        acc[option.value] = 0;
        return acc;
     }, {});
 
     // Fill in the actual values from the API data
     data.forEach(item => {
       const project = Boolean(item.project) ? item.project.split('~').filter(Boolean) : null ;
       project?.forEach(pr => {
           ProjectSums[parseInt(pr)] += item.sum;
       })
     });
    this.setState({ projectData: data ,ProjectSums});
    
  };

  handleFail = () => {
    console.error("Failed to fetch data");
  };

  render() {
    const {  ProjectOptions ,ProjectSums} = this.state;
    // Calculate the total sum of all project values
    const totalSum = Object.values(ProjectSums).filter(Boolean).reduce((total, value) => total + value, 0);
    return (
      <ApiUiController inApiCall={false}>
        <div>
          <h2>Leads By Project  Report</h2>
          <hr />
          <div className="row mt-3">
          <Table striped bordered hover className="col-md-6">
            <thead>
              <tr>
                <th>Project</th>
                <th>Total</th>
              </tr>
            </thead>
            <tbody>
              {ProjectOptions.map((option, index) => (
                <tr key={index}>
                  <td>{option.label}</td>
                  <td>{ProjectSums[option.value]}</td>
                </tr>
              ))}
              <tr>
                <td><strong>Total</strong></td>
                <td><strong>{totalSum}</strong></td>
              </tr>
            </tbody>
          </Table>
           {/* Chart in col-md-5 */}
           <div className="col-md-6">
              {/* Pass only progressSums and progressOptions to ChartComponent */}
              <ChartComponent progressSums={ProjectSums} progressOptions={ProjectOptions} type={"pie"}/>
          </div>
        </div>
        </div>
      </ApiUiController>
    );
  }
}

export default withRouter(DailySalesLeadByProject);
